import React from "react";
import { ABOUT_PAGE } from "../../content/siteContent";

export const AboutValuesSection = () => {
  return (
    <section className="team-area-six pb-120">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-8">
            <div className="section-title section-title-three text-center mb-50">
              <span className="sub-title">Core Values</span>
              <h2 className="title">What guides our work</h2>
              <p>{ABOUT_PAGE.recognition}</p>
            </div>
          </div>
        </div>

        <div className="row justify-content-center">
          {ABOUT_PAGE.coreValues.map((item) => (
            <div key={item.title} className="col-lg-3 col-md-6">
              <div className="services-item-four h-100">
                <div className="services-icon-four">
                  <i className="flaticon-inspiration"></i>
                </div>
                <div className="services-content-four">
                  <h2 className="title">{item.title}</h2>
                  <p>{item.text}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
